export default function SolutionsShowcase() {
  const solutions = [
    {
      icon: 'ri-robot-2-line',
      title: 'Agentic AI Implementation',
      description: 'Deploy autonomous AI agents that execute complex workflows with minimal human intervention',
      gradient: 'from-[#1e3a8a] to-[#3b82f6]'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'AI Governance & Risk Frameworks',
      description: 'Establish enterprise-grade controls, compliance protocols, and ethical AI guidelines',
      gradient: 'from-[#1e40af] to-[#60a5fa]'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Data & Cloud Modernization',
      description: 'Build scalable data infrastructure optimized for AI workloads and real-time processing',
      gradient: 'from-[#2563eb] to-[#93c5fd]'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Enterprise AI Operating Model',
      description: 'Design organizational structures, roles, and processes for sustained AI innovation',
      gradient: 'from-[#1e3a8a] to-[#3b82f6]'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Pilot-to-Production Acceleration',
      description: 'Transform experimental AI projects into production-ready enterprise solutions',
      gradient: 'from-[#1e40af] to-[#60a5fa]'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'ROI & Value Measurement',
      description: 'Implement frameworks to track, measure, and optimize AI business impact',
      gradient: 'from-[#2563eb] to-[#93c5fd]'
    }
  ];

  return (
    <section id="solutions" className="py-28 bg-[#f8f7f5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Enterprises Don't Fail at AI.<br />
            <span className="text-[#1e3a8a]">They Fail at Scaling.</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Covasant helps enterprises move from experimentation to production using proven frameworks, secure governance, and scalable architecture.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${solution.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${solution.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{solution.title}</h3>
              <p className="text-gray-600 leading-relaxed">{solution.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="#leaders"
            className="inline-flex items-center gap-2 bg-[#1e3a8a] hover:bg-[#1e40af] text-white px-8 py-4 rounded-lg font-semibold transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
          >
            Schedule a Strategy Conversation
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
